export { SingleCafesRestaurantsPointPage } from "./single-cafes-restaurants-point-page";
